import { homeContent } from './homeContent';

type HeroContent = (typeof homeContent)['hero']['en'];

const heroPatch: Record<string, HeroContent> = {
  hi: {
    badge: 'एंटरप्राइज-ग्रेड BPO और डिजिटल फैक्ट्री',
    h1: 'दुनिया की अग्रणी BPO और डिजिटल फैक्ट्री — मोरक्को, स्पेन और दुबई से वैश्विक व्यवसायों को शक्ति',
    sub: 'बहुभाषी, एंटरप्राइज क्लाइंट। आपके ग्राहकों के लिए सेवाएँ।',
    ctaPrimary: 'कोटेशन का अनुरोध करें',
    ctaSecondary: 'संपर्क करें',
    trustBadge: 'बहुभाषी टीमें • कैसाब्लांका, मोरक्को',
    microProof: [
      '24/7/365 कवरेज',
      'बहुभाषी टीमें (EN/FR/ES/AR + 8 और)',
      'पश्चिमी यूरोप/USA की तुलना में',
      'आपकी ज़रूरत के अनुसार टीम',
      'GDPR'
    ],
    proofMetrics: [
      { value: '', label: 'भाषाएँ', description: 'बहुभाषी टीमें उपलब्ध' },
      { value: '', label: 'चैनल', description: 'फ़ोन, चैट, ईमेल, सोशल मीडिया' },
      { value: '', label: 'Nearshore', description: 'कैसाब्लांका, मोरक्को स्थित' }
    ],
    trustedBy: 'बहुभाषी BPO • कैसाब्लांका, मोरक्को',
    dialogTitle: 'डिस्कवरी कॉल शेड्यूल करें',
  },
  ro: {
    badge: 'BPO & Fabrică Digitală de nivel enterprise',
    h1: 'Lider global în BPO & Fabrică Digitală — impulsionăm afaceri din Maroc și Spania',
    sub: 'Multilingv, pentru clienții dumneavoastră.',
    ctaPrimary: 'Solicitați o ofertă',
    ctaSecondary: 'Contactați-ne',
    trustBadge: 'Echipe multilingve • Sediu în Casablanca, Maroc',
    microProof: [
      'Acoperire 24/7/365',
      'Echipe multilingve (EN/FR/ES/AR + încă 8)',
      'vs Europa de Vest/SUA',
      'Echipă dedicată conform nevoilor',
      'GDPR'
    ],
    proofMetrics: [
      { value: '', label: 'Limbi', description: 'Echipe multilingve disponibile' },
      { value: '', label: 'Canale', description: 'Voce, chat, email, social media' },
      { value: '', label: 'Nearshore', description: 'Sediu în Casablanca, Maroc' }
    ],
    trustedBy: 'BPO multilingv • Casablanca, Maroc',
    dialogTitle: 'Programează un Discovery Call',
  },
  cs: {
    badge: 'Enterprise BPO & Digitální Studio',
    h1: 'Světový lídr v BPO a digitální továrně — růst globálních firem z Maroka, Španělska a Dubaje',
    sub: 'Vícejazyčný, pro vaše zákazníky.',
    ctaPrimary: 'Vyžádat nabídku',
    ctaSecondary: 'Kontaktujte nás',
    trustBadge: 'Vícejazyčné týmy • Sídlo v Casablance, Maroko',
    microProof: [
      'Pokrytí 24/7/365',
      'Vícejazyčné týmy (EN/FR/ES/AR + 8 dalších)',
      'oproti západní Evropě/USA',
      'Tým přizpůsobený vašim potřebám',
      'Soulad s • GDPR'
    ],
    proofMetrics: [
      { value: '', label: 'Jazyky', description: 'Vícejazyčné týmy k dispozici' },
      { value: '', label: 'Kanály', description: 'Hlas, chat, email, sociální sítě' },
      { value: '', label: 'Nearshore', description: 'Sídlo v Casablance, Maroko' }
    ],
    trustedBy: 'Vícejazyčné BPO • Casablanca, Maroko',
    dialogTitle: 'Naplánovat úvodní hovor',
  },
  hu: {
    badge: 'Vállalati szintű BPO és Digitális Gyár',
    h1: 'A világ vezető BPO és Digitális Gyára — globális növekedés Marokkóból, Spanyolországból és Dubajból',
    sub: 'Többnyelvű, az Ön ügyfelei számára.',
    ctaPrimary: 'Kérjen ajánlatot',
    ctaSecondary: 'Kapcsolatfelvétel',
    trustBadge: 'Többnyelvű csapatok • Székhely: Casablanca, Marokkó',
    microProof: [
      '24/7/365 lefedettség',
      'Többnyelvű csapatok (EN/FR/ES/AR + 8 további)',
      'Nyugat-Európához/USA-hoz képest',
      'Az Ön igényeire szabott csapat',
      'GDPR'
    ],
    proofMetrics: [
      { value: '', label: 'Nyelvek', description: 'Többnyelvű csapatok elérhetők' },
      { value: '', label: 'Csatornák', description: 'Hang, chat, email, közösségi média' },
      { value: '', label: 'Nearshore', description: 'Székhely: Casablanca, Marokkó' }
    ],
    trustedBy: 'Többnyelvű BPO • Casablanca, Marokkó',
    dialogTitle: 'Felfedező hívás foglalása',
  },
  fi: {
    badge: 'Enterprise-tason BPO ja digitaalinen tehdas',
    h1: 'Maailman johtava BPO ja digitaalinen tehdas — vauhditamme globaalia kasvua Marokosta ja Espanjasta',
    sub: 'Monikielinen, asiakkaillenne.',
    ctaPrimary: 'Pyydä tarjous',
    ctaSecondary: 'Ota yhteyttä',
    trustBadge: 'Monikieliset tiimit • Päätoimipaikka Casablanca, Marokko',
    microProof: [
      '24/7/365 kattavuus',
      'Monikieliset tiimit (EN/FR/ES/AR + 8 muuta)',
      'verrattuna Länsi-Eurooppaan/USA:han',
      'Tarpeisiinne räätälöity tiimi',
      'GDPR'
    ],
    proofMetrics: [
      { value: '', label: 'Kielet', description: 'Monikieliset tiimit saatavilla' },
      { value: '', label: 'Kanavat', description: 'Puhelin, chat, sähköposti, some' },
      { value: '', label: 'Nearshore', description: 'Päätoimipaikka Casablanca, Marokko' }
    ],
    trustedBy: 'Monikielinen BPO • Casablanca, Marokko',
    dialogTitle: 'Varaa kartoituspuhelu',
  },
};

/**
 * Adds homepage hero translations for hi/ro/cs/hu/fi.
 * Called once at app startup.
 */
export function applyHomeContentTier2Patch() {
  const hero = homeContent.hero as Record<string, HeroContent>;

  for (const [lang, data] of Object.entries(heroPatch)) {
    hero[lang] = data;
  }
}
